import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        psychologists: [],
    },
    // -----------------------------------------------------------------
    getters: {
        all: (state) => { return state.psychologists },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_PSYCHOLOGISTS(state, psychologists) {
            state.psychologists = psychologists
        },
        PUSH_PSYCHOLOGISTS(state, psychologists) {
            state.psychologists = state.psychologists.concat(psychologists)
        },
    },
    // -----------------------------------------------------------------
    actions: {
        index: (context, data) => {
            return Vue.api.get('psychologists', { params: data })
                .then(response => {
                    context.commit((data.page === 1) ? 'SET_PSYCHOLOGISTS' : 'PUSH_PSYCHOLOGISTS', response.data.data)
                    return response.data
                })
                .catch(error => { throw error.response.data.error })
        },
        read: (context, id) => {
            return Vue.api.get(`psychologists/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        create: (context, data) => {
            return Vue.api.post(`psychologists`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        invite: (context, data) => {
            return Vue.api.post(`psychologist-invites`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        update: (context, data) => {
            return Vue.api.put(`psychologists/${data.id}`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        delete: (context, data) => {
            return Vue.api.delete(`psychologists/${data.id}`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        codes: (context, id) => {
            return Vue.api.get(`psychologists/${id}/discount-codes`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        users: (context, id) => {
            return Vue.api.get(`psychologists/${id}/users`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        assignUser: (context, data) => {
            return Vue.api.post(`psychologists/${data.id}/users`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        list: () => {
            return Vue.api.get(`lists/psychologists`)
            .then(response => {
                return response.data.data
            })
            .catch(error => { throw error.response.data.error })
        }
    }
}
